import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiClient} from '../../../services/api/userway-api.service';
import {
  GetPublicAccountInfoData,
  PasswordResetEmailRequestDto,
  ResetPasswordData,
  ResetPasswordDto,
  SendEmailMfaVerificationData,
  SendPasswordResetEmailData,
  SsoV0PublicServiceUserLoginCreateData,
  SsoV0PublicServiceUserRefreshTokenListData,
  UserLoginDto,
} from '../../../../userway/sdk/SSOApiClient';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(private apiClient: ApiClient) {}

  signIn(signIn: UserLoginDto): Observable<SsoV0PublicServiceUserLoginCreateData> {
    const request = this.apiClient.ssoApi.api.ssoV0PublicServiceUserLoginCreate(signIn);
    return this.apiClient.fetch(request);
  }

  forgot(forgot: PasswordResetEmailRequestDto): Observable<SendPasswordResetEmailData> {
    const request = this.apiClient.ssoApi.serviceUserController.sendPasswordResetEmail(forgot);
    return this.apiClient.fetch(request);
  }

  sendEmailVerification(email: string): Observable<SendEmailMfaVerificationData> {
    const request = this.apiClient.ssoApi.mfaEmailController.sendEmailMfaVerification({email});
    return this.apiClient.fetch(request);
  }

  recovery(recovery: ResetPasswordDto): Observable<ResetPasswordData> {
    const request = this.apiClient.ssoApi.serviceUserController.resetPassword(recovery);
    return this.apiClient.fetch(request);
  }

  refreshToken(refreshToken: string): Observable<SsoV0PublicServiceUserRefreshTokenListData> {
    const headers = this.apiClient.createAxiosCustomHeaderContext({
      'X-Sso-Request-Origin': 'WIDGET_ORIGIN',
      Authorization: refreshToken,
    });
    const request = this.apiClient.ssoApi.api.ssoV0PublicServiceUserRefreshTokenList({headers});
    return this.apiClient.fetch(request);
  }

  getServiceAccount(domain: string): Observable<GetPublicAccountInfoData> {
    const headers = this.apiClient.createAxiosCustomHeaderContext({
      'X-Sso-Request-Origin': 'SCANNER_ORIGIN',
      skip: 'true',
    });
    const request = this.apiClient.ssoApi.serviceAccountController.getPublicAccountInfo({domain}, {headers});
    return this.apiClient.fetch(request);
  }
}
